import { minutesToMilliseconds } from "date-fns";

import type { GetBaseSearchServiceResponse, InternalApiSearchServiceOptions } from "@performyard/service-contracts";

import { getInteralApiSearchService } from "../../services/defs/internal-api/search-service";

export const searchServiceQuery = (params: InternalApiSearchServiceOptions) => ({
	queryKey: ["search-service", JSON.stringify(params)],
	queryFn: (): Promise<GetBaseSearchServiceResponse> => getInteralApiSearchService(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error fetching results from search service.",
	},
});
